import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=664abf3c&scoped=true&"
import script from "./ErrorContent.vue?vue&type=script&lang=js&"
export * from "./ErrorContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664abf3c",
  null
  
)

export default component.exports